import { FunctionComponent } from "react"
import ForgotPasswordForm from "../features/auth/components/forgot-password-form"

const ForgotPassword: FunctionComponent = () => {
  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-col pt-[170px] px-8 pb-12 box-border items-center justify-start">
      <ForgotPasswordForm />
    </div>
  )
}

export default ForgotPassword
